import React, { useState } from 'react';

import * as styles from './VideoWithThumbnail.style';

export interface VideoWithThumbnailProps {
  youtubeId: string;
  thumbnail: string;
  trackClick: VoidFunction;
}

export const YOUTUBE_CONTAINER = 'youtube-container';
export const VIDEO_THUMBNAIL = 'video-thumbnail';
export const YOUTUBE_IFRAME = 'youtube-iframe';

export const VideoWithThumbnail = ({
  youtubeId,
  thumbnail,
  trackClick,
}: VideoWithThumbnailProps) => {
  const [shouldRenderVideo, setRenderVideo] = useState(false);

  const loadGTMScript = () => {
    const script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    if (firstScriptTag.parentNode) {
      firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
    }
  };

  const handleMouseDown = () => {
    loadGTMScript();
    trackClick();
    setRenderVideo(true);
  };

  return (
    <div
      css={styles.VideoPlayerWrapper}
      className="youtube-container"
      data-id={youtubeId}
      data-testid={YOUTUBE_CONTAINER}
    >
      {shouldRenderVideo ? (
        <div css={styles.VideoPlayer}>
          <iframe
            data-testid={YOUTUBE_IFRAME}
            css={styles.YoutubeIframe}
            title={youtubeId}
            src={`//www.youtube.com/embed/${youtubeId}?rel=0&autoplay=1&autohide=2&border=0&wmode=opaque&enablejsapi=1&showinfo=0`}
            frameBorder="0"
            allowFullScreen={false}
          />
        </div>
      ) : (
        <button
          data-testid={VIDEO_THUMBNAIL}
          css={styles.VideoPlayer}
          onMouseDown={handleMouseDown}
        >
          <img
            css={styles.VideoThumbnail}
            className="videocover"
            src={thumbnail}
            alt="video cover"
          />
        </button>
      )}
    </div>
  );
};
